import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/lib/auth';
import { workspacesApi } from '@/lib/api';
import { useAppStore } from '@/stores/appStore';

/**
 * The signed-in user's effective role on the current workspace (per-brand
 * scoping applied), or undefined while loading. Use it to hide actions the API
 * would refuse; the server still enforces every check.
 */
export function useWorkspaceRole(): string | undefined {
  const { getToken } = useAuth();
  const { currentWorkspace } = useAppStore();
  const { data } = useQuery({
    queryKey: ['workspace-role', currentWorkspace?.id],
    queryFn: async () => {
      const token = await getToken();
      return workspacesApi.get(token!, currentWorkspace!.id);
    },
    enabled: !!currentWorkspace,
    staleTime: 5 * 60_000,
  });
  return data?.role;
}

export const canEditWorkspace = (role: string | undefined) =>
  !!role && ['owner', 'admin', 'editor'].includes(role);
